<template>
  <div class="dashboard-in-progress">
    <Loader :loading="true" />
  </div>
</template>

<script>
import { userHasRole } from '@/services/helper'
import Loader from '@/components/loader'
export default {
  name: 'dashboard',
  components: { Loader },
  created () {
    this.$store.dispatch('getUser')
      .then(response => {
        if (response.code === 200) {
          switch (true) {
            case userHasRole(response.data.user.roles, 'admin'):
              this.$router.push({name: 'users'})
              break
            case userHasRole(response.data.user.roles, 'accountant'):
              this.$router.push({name: 'tranches'})
              break
            default:
              this.$router.push({name: 'tools'})
          }
        }
      })
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
@import 'src/pages/dashboard/base';

.dashboard-in-progress {
  position: relative;
  min-height: 300px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// dashboard.vue?6382634a